<li *ngIf="!!menu && !menu.hidden" class="nav-item dropdown" 
    [sq-action-item]="{item: menu, size: size, autoAdjust: autoAdjust, autoAdjustBreakpoint: autoAdjustBreakpoint, inMenu: true, rightAligned: true}"
    [collapseBreakpoint]="collapseBreakpoint"
></li>